import { AgentEngineId, IAgentGenerationLog } from '@/types/response';
import { Space, Tag, Typography } from 'antd';

const { Text } = Typography;

export const ENGINE_TAG_COLOR: Record<AgentEngineId, string> = {
  outing: 'cyan',
  kinjo: 'green',
  otoku: 'orange',
  kigen: 'red',
  worry: 'geekblue',
  shocho: 'purple',
};

export const MESSAGE_STATUS_TAG: Record<
  string,
  { label: string; color: string }
> = {
  posted: { label: '投稿済み', color: 'green' },
  generated: { label: '生成のみ', color: 'default' },
};

// URL は AI の web 検索結果（外部由来データ）なので http(s) のみリンク化する
const isSafeHttpUrl = (url: string): boolean => /^https?:\/\//i.test(url);

export const GenerationLogView: React.FC<{
  log: IAgentGenerationLog | null;
}> = ({ log }) => {
  if (!log) return <Text type='secondary'>ログなし</Text>;

  return (
    <Space direction='vertical' style={{ width: '100%' }} size='small'>
      <div>
        <Text strong style={{ display: 'block', marginBottom: 4 }}>
          検索クエリ（{log.searchProvider}）
        </Text>
        <Space wrap size={[4, 4]}>
          {log.queries.map((q) => (
            <Tag key={q}>{q}</Tag>
          ))}
        </Space>
      </div>
      {log.address && <Text type='secondary'>基準住所: {log.address}</Text>}
      {log.results.length > 0 && (
        <div>
          <Text strong style={{ display: 'block', marginBottom: 4 }}>
            検索結果（{log.results.length}件）
          </Text>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {log.results.map((r) => (
              <li key={r.url} style={{ fontSize: 12, marginBottom: 2 }}>
                {isSafeHttpUrl(r.url) ? (
                  <a href={r.url} target='_blank' rel='noopener noreferrer'>
                    {r.title || r.url}
                  </a>
                ) : (
                  <Text style={{ fontSize: 12 }}>{r.title || r.url}</Text>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      {log.selectionLog && (
        <div>
          <Text strong style={{ display: 'block', marginBottom: 4 }}>
            選定ログ（テスト用・トークには投稿されない）
          </Text>
          <pre
            style={{
              background: '#fafafa',
              padding: 12,
              borderRadius: 4,
              fontSize: 12,
              whiteSpace: 'pre-wrap',
              margin: 0,
            }}
          >
            {log.selectionLog}
          </pre>
        </div>
      )}
    </Space>
  );
};
